module.exports = __webpack_public_path__ + "img/dragon.f48bfd0c.png";